import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { TagsProvider, useTagsContext } from 'pages/settings/pages/tags/context/tagsContext'
import { TagsEmpty } from 'pages/settings/pages/tags/ui/TagsEmpty/TagsEmpty'
import { TagsList } from 'pages/settings/pages/tags/ui/TagsList/TagsList'

const Tags = observer(() => {
  const { init, dispose, isEmpty, initialLoading } = useTagsContext()

  useEffect(() => {
    init()

    return () => {
      dispose()
    }
  }, [])

  if (initialLoading) return <SpinnerLoader ariaLabel={'TagsPage'} />
  if (isEmpty) return <TagsEmpty />

  return <TagsList />
})

export const TagsPage = observer(() => (
  <FullPageWrapper>
    <TagsProvider>
      <Tags />
    </TagsProvider>
  </FullPageWrapper>
))
